module.exports = __webpack_public_path__ + "static/media/ic-CSA.d8ba5e4d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic-CSA.svg
// module id = 1289
// module chunks = 17